// ═══ 업무별 기록 (폐차·이전 엑셀 기록, 2026-08-31 까지) — 대표·직원 공용 네비 탭 ═══
// 연결 = "이 기록은 어느 업체 것" 표시만 바꾼다(미수 영향 없음). 장부에는 v5 묶음 카드 [장부에 반영]으로만 들어간다
//   (DESIGN_V5 — '장부 반영' RecordsCards · '확인 항목' RecordsGaps · '처리 기록' RecordsHistory, v2 미수 맞춤 확정 폐지).
// 직원도 연결·업체 생성·미수 등록 전부 가능 → 이 화면은 /work-records* 만 부른다
//   (기존 거래처·청구 계정·수기 조정 API 는 직원 403 이라 쓰지 않는다).
// 서버 계약 (routes/workRecords.js, DESIGN §2·§7):
//   GET  /work-records/summary?jobKind → {success, counts:{item:{total,unlinked,auto,manual}, deposit:{total,unlinked,linked}, side_item, adjust, excluded}}
//   GET  /work-records?jobKind&recKind&status&q&from&to&offset&limit → {success, total, rows:[…]}   recKind 단일값
//   GET  /work-records/name-groups?jobKind&status → {success, groups:[…]}
//   POST /work-records/link {jobKind, unitId(0=해제), ids|rawName, version?(ids 1개)} → {success, updated, skipped}
//        409 VERSION_CONFLICT → 안내 + 목록 재조회
//   GET  /work-records/:id/history → {success, history:[{fromUnitName,toUnitName,mode,actorName,at}]}
//   GET  /work-records/erp-items?jobKind&month → {success, rows:[{id,date,month,carNo,jobKind,unitName,subtotal,source}]}
// 하위 탭: '건' = item + side_item(부속표), '입금' = deposit + adjust — 서버 recKind 가 단일값이라 탭 안 토글로 고른다.
// 실시간: records:updated {agencyId, jobKind} → 보고 있는 업무면 300ms debounce 재조회 (CancelAgencySettlement 소켓 관례).
import React, { useState, useEffect, useRef } from 'react';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';
import { useIsMobile, hScroll } from '../utils/useMobile';
import { is } from './SettlementItemDrawer';
import CaHeaderTabs from './CaHeaderTabs';
import RecordsUnitPicker from './RecordsUnitPicker';
import RecordsCards from './RecordsCards';
import RecordsGaps from './RecordsGaps';
import RecordsHistory from './RecordsHistory';
import RecordsHintLinkModal from './RecordsHintLinkModal';
import RecordsRow, { recordCols } from './RecordsRow';

var JOBS = ['폐차', '이전'];
var PAGE = 100;
var CONFLICT_MSG = '다른 사람이 먼저 수정했습니다. 목록을 새로 불러왔습니다.';
var SUBS = [['cards', '장부 반영'], ['gaps', '확인 항목'], ['names', '이름별 정리'], ['items', '건'], ['deposits', '입금'], ['excluded', '제외'], ['erp', '9월 이후'], ['history', '처리 기록']];
var LIST_KINDS = { items: [['item', '차량 건'], ['side_item', '부속표']], deposits: [['deposit', '입금'], ['adjust', '조정']], excluded: [['excluded', '제외']] };
var STATUS = [['all', '전체'], ['unlinked', '미연결'], ['auto', '자동 연결'], ['manual', '직접 연결']];

var fmt = function (n) { return (parseInt(n, 10) || 0).toLocaleString(); };
var cnt = function (v) { return (v && typeof v === 'object') ? (parseInt(v.total, 10) || 0) : (parseInt(v, 10) || 0); };
var enc = encodeURIComponent;
var post = function (url, body) {
  return authFetch(API + url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
    .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, data: d || {} }; }); });
};
var curMonth = function () { var d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0'); };
var th = { padding: '8px 6px', fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap', textAlign: 'left', color: '#64748b', background: '#f8fafc' };
var td = { padding: '6px', fontSize: 12, whiteSpace: 'nowrap', borderTop: '1px solid #f1f5f9', verticalAlign: 'top' };
var hintSt = { margin: '0 0 10px', fontSize: 12.5, color: '#64748b', lineHeight: 1.6 };
var errBox = function (err) {
  return err ? <div style={{ padding: 12, background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, color: '#b91c1c', fontSize: 12.5, marginBottom: 10 }}>{err}</div> : null;
};
var pill = function (on) {
  return { padding: '4px 10px', borderRadius: 14, fontSize: 12, fontWeight: on ? 700 : 500, cursor: 'pointer', fontFamily: 'inherit',
    border: '1px solid ' + (on ? '#2563EB' : '#e2e8f0'), background: on ? '#eff6ff' : '#fff', color: on ? '#1d4ed8' : '#64748b' };
};

// ── 이름별 정리 — 원문 이름 묶음 일괄 연결 (수동 연결 건은 서버가 보존) ──
function NameGroups(props) {
  var jobKind = props.jobKind, showToast = props.showToast;
  var isMobile = useIsMobile();
  var [status, setStatus] = useState('unlinked');
  var [groups, setGroups] = useState(null);
  var [err, setErr] = useState('');
  var [pickFor, setPickFor] = useState(null);  // 그룹 — 업체 고르기 팝업
  var [chip, setChip] = useState(null);        // {g, s} — 추천 칩 확인 줄
  var [busy, setBusy] = useState(false);

  useEffect(function () {
    var alive = true;
    authFetch(API + '/work-records/name-groups?jobKind=' + enc(jobKind) + '&status=' + status)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!alive) return;
        if (!d || !d.success || !Array.isArray(d.groups)) { setErr((d && d.error) || '조회 실패'); setGroups([]); return; }
        setErr(''); setGroups(d.groups);
      }).catch(function () { if (alive) { setErr('조회 실패'); setGroups([]); } });
    return function () { alive = false; };
  }, [jobKind, status, props.reloadKey]);

  // 일괄 연결은 업체 지정만 (unitId 0 = 해제는 건 목록의 [연결 해제] 로만) · 빈 이름 묶음은 대상 아님
  var link = function (g, unitId) {
    if (!(unitId > 0) || !String(g.clientRaw || '').trim()) return;
    setBusy(true);
    post('/work-records/link', { jobKind: jobKind, rawName: g.clientRaw, unitId: unitId }).then(function (res) {
      setBusy(false);
      if (!res.data.success) { showToast(res.data.error || '연결 실패', 'err'); return; }
      showToast('\'' + g.clientRaw + '\' ' + (res.data.updated || 0) + '건을 연결했습니다');
      setPickFor(null); setChip(null); props.onChanged();
    }).catch(function () { setBusy(false); showToast('서버 오류', 'err'); });
  };

  return (<div>
    <p style={hintSt}>엑셀 원문 거래처 이름별로 모았습니다. [업체 연결]로 그 이름의 미연결·자동 연결 건을 한 번에 업체에 연결합니다. 직접 연결한 건은 그대로 유지됩니다.</p>
    <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
      <button type="button" style={pill(status === 'unlinked')} onClick={function () { setStatus('unlinked'); }}>미연결 남은 이름</button>
      <button type="button" style={pill(status === 'all')} onClick={function () { setStatus('all'); }}>전체 이름</button>
    </div>
    {errBox(err)}
    <div style={isMobile ? hScroll : { overflowX: 'auto' }}>
      <table style={{ width: '100%', minWidth: 860, borderCollapse: 'collapse', background: '#fff', border: '1px solid #e2e8f0' }}>
        <thead><tr>{['원문 이름', '건수', '금액', '기간', '연결 상태', '추천 업체', ''].map(function (h, i) {
          return <th key={i} style={i === 1 || i === 2 ? Object.assign({}, th, { textAlign: 'right' }) : th}>{h}</th>;
        })}</tr></thead>
        <tbody>{(groups || []).map(function (g) {
          var showChip = chip && chip.g.clientRaw === g.clientRaw;
          var blank = !String(g.clientRaw || '').trim();
          return (<React.Fragment key={g.clientRaw}>
            <tr data-testid="name-group">
              <td style={Object.assign({}, td, { fontWeight: 700, color: '#1B3A5C' })}>{g.clientRaw || '(빈 이름)'}</td>
              <td style={Object.assign({}, td, { textAlign: 'right' })}>{fmt(g.count)}</td>
              <td style={Object.assign({}, td, { textAlign: 'right' })}>{fmt(g.amount)}</td>
              <td style={Object.assign({}, td, { color: '#64748b' })}>{(g.firstDate || '-') + ' ~ ' + (g.lastDate || '-')}</td>
              <td style={Object.assign({}, td, { whiteSpace: 'normal' })}>
                {(g.linked || []).map(function (l) { return <div key={l.unitId}>{l.unitName} <span style={{ color: '#94a3b8' }}>{fmt(l.count)}건</span></div>; })}
                {(g.unlinkedCount || 0) > 0 && <div style={{ color: '#b45309' }}>미연결 {fmt(g.unlinkedCount)}건</div>}
              </td>
              <td style={Object.assign({}, td, { whiteSpace: 'normal' })}>{(blank ? [] : (g.suggestions || [])).map(function (s) {
                return (<button key={s.unitId} type="button" aria-label={'추천 ' + s.name} disabled={busy}
                  title={s.why === 'exact' ? '이름 일치' : '비슷한 이름'} onClick={function () { setChip({ g: g, s: s }); }}
                  style={Object.assign({ margin: '0 4px 4px 0' }, pill(false))}>{s.name}{s.accountName && s.accountName !== s.name ? ' · ' + s.accountName : ''}</button>);
              })}</td>
              <td style={blank ? Object.assign({}, td, { whiteSpace: 'normal', color: '#94a3b8', fontSize: 11.5 }) : td}>{blank
                ? '이름 없는 건은 건 목록에서 골라 연결해 주세요.'
                : <button className="btn btn-outline btn-sm" disabled={busy} aria-label={'업체 연결 ' + g.clientRaw} onClick={function () { setPickFor(g); }}>업체 연결</button>}</td>
            </tr>
            {showChip && <tr><td colSpan={7} style={Object.assign({}, td, { background: '#eff6ff', whiteSpace: 'normal' })}>
              <span style={{ fontSize: 12.5, color: '#1d4ed8' }}>'{g.clientRaw}' 건을 <b>{chip.s.name}</b>(으)로 연결합니다.</span>
              <button className="btn btn-blue btn-sm" style={{ marginLeft: 8 }} disabled={busy} onClick={function () { link(g, chip.s.unitId); }}>연결</button>
              <button className="btn btn-outline btn-sm" style={{ marginLeft: 4 }} disabled={busy} onClick={function () { setChip(null); }}>닫기</button>
            </td></tr>}
          </React.Fragment>);
        })}
        {!!groups && !groups.length && <tr><td colSpan={7} style={Object.assign({}, td, { padding: 20, textAlign: 'center', color: '#94a3b8' })}>{status === 'unlinked' ? '미연결 이름이 없습니다' : '이름이 없습니다'}</td></tr>}
        {!groups && <tr><td colSpan={7} style={Object.assign({}, td, { padding: 20, textAlign: 'center', color: '#94a3b8' })}>조회 중…</td></tr>}
        </tbody>
      </table>
    </div>
    {!!pickFor && <RecordsUnitPicker title={'\'' + pickFor.clientRaw + '\' 업체 연결'} initialName={pickFor.clientRaw} busy={busy} showToast={showToast}
      hint="이 원문 이름의 미연결·자동 연결 건을 고른 업체에 연결합니다."
      onClose={function () { setPickFor(null); }} onPick={function (u) { link(pickFor, u.unitId); }} />}
  </div>);
}

// ── 건 / 입금 / 제외 목록 — 필터 · 페이지(100) · 다건 연결/해제 · 행 펼침(상세·이력) ──
function RecordList(props) {
  var jobKind = props.jobKind, tab = props.tab, showToast = props.showToast, onChanged = props.onChanged;
  var scope = props.scope;   // 장부 반영 카드의 '미연결 보기' — {sheet, rowFrom, rowTo} (상태 기본 = 미연결)
  var isMobile = useIsMobile();
  var kinds = LIST_KINDS[tab];
  var linkable = tab !== 'excluded';
  var [kind, setKind] = useState(kinds[0][0]);
  var [status, setStatus] = useState(scope ? 'unlinked' : 'all');
  var [hints, setHints] = useState(false);   // 참고 업체로 일괄 연결 미리보기
  var [qIn, setQIn] = useState('');
  var [q, setQ] = useState('');
  var [from, setFrom] = useState('');
  var [to, setTo] = useState('');
  var [offset, setOffset] = useState(0);
  var [data, setData] = useState(null);
  var [err, setErr] = useState('');
  var [loading, setLoading] = useState(false);
  var [sel, setSel] = useState({});
  var [open, setOpen] = useState(0);
  var [hist, setHist] = useState(null);
  var [picker, setPicker] = useState(null);  // {ids, version}
  var [unlink, setUnlink] = useState(null);  // {ids, version}
  var [busy, setBusy] = useState(false);

  var qs = '?jobKind=' + enc(jobKind) + '&recKind=' + kind + '&status=' + (linkable ? status : 'all') + (q ? '&q=' + enc(q) : '')
    + (from ? '&from=' + from : '') + (to ? '&to=' + to : '')
    + (scope ? '&sheet=' + enc(scope.sheet) + '&rowFrom=' + scope.rowFrom + '&rowTo=' + scope.rowTo : '') + '&offset=' + offset + '&limit=' + PAGE;
  useEffect(function () {
    var alive = true;
    setLoading(true);
    authFetch(API + '/work-records' + qs)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!alive) return;
        if (!d || !d.success || !Array.isArray(d.rows)) { setErr((d && d.error) || '조회 실패'); setLoading(false); return; }
        setErr(''); setData({ total: parseInt(d.total, 10) || 0, rows: d.rows }); setLoading(false);
      }).catch(function () { if (alive) { setErr('조회 실패'); setLoading(false); } });
    return function () { alive = false; };
  }, [qs, props.reloadKey]);

  useEffect(function () {
    if (!open || !linkable) return undefined;
    var alive = true;
    setHist(null);
    authFetch(API + '/work-records/' + open + '/history')
      .then(function (r) { return r.json(); })
      .then(function (d) { if (alive) setHist(d && d.success && Array.isArray(d.history) ? d.history : []); })
      .catch(function () { if (alive) setHist([]); });
    return function () { alive = false; };
  }, [open, props.reloadKey, linkable]);

  var rows = (data && data.rows) || [];
  var total = (data && data.total) || 0;
  var selIds = Object.keys(sel).map(function (k) { return parseInt(k, 10); });
  var refilter = function (fn) { return function (v) { fn(v); setOffset(0); setSel({}); setOpen(0); }; };
  var versionOf = function (ids) {
    if (ids.length !== 1) return undefined;
    var r = rows.filter(function (x) { return x.id === ids[0]; })[0];
    return r ? r.version : undefined;
  };

  var doLink = function (ids, unitId, version) {
    var body = { jobKind: jobKind, ids: ids, unitId: unitId };
    if (ids.length === 1 && version != null) body.version = version;
    setBusy(true);
    post('/work-records/link', body).then(function (res) {
      setBusy(false);
      var d = res.data;
      if (res.status === 409 && d.code === 'VERSION_CONFLICT') {
        showToast(CONFLICT_MSG, 'err');
        setPicker(null); setUnlink(null); setSel({}); onChanged(); return;
      }
      if (!d.success) { showToast(d.error || '처리 실패', 'err'); return; }
      var skipped = (d.skipped || []).length;
      showToast((d.updated || 0) + '건 ' + (unitId ? '연결했습니다' : '연결을 해제했습니다') + (skipped ? ' · ' + skipped + '건은 변경 없음' : ''));
      setPicker(null); setUnlink(null); setSel({}); onChanged();
    }).catch(function () { setBusy(false); showToast('서버 오류', 'err'); });
  };

  var cols = recordCols(tab, jobKind);
  var colCount = cols.length + (linkable ? 1 : 0);


  var dateIn = Object.assign({}, is, { width: 140, padding: '5px 8px', fontSize: 12 });
  return (<div>
    {tab === 'deposits' && <p style={hintSt}>엑셀 입금 기록입니다. '참고'는 엑셀에서 바로 위 차량 묶음의 거래처입니다. [참고 업체로 일괄 연결]은 미리보기를 확인한 뒤 연결하고, 나머지는 직접 골라 연결합니다.</p>}
    {tab === 'excluded' && <p style={hintSt}>사본·빈 양식·말소 시트 중복·금액 없는 행으로 기록에서 뺀 줄입니다. 원본 위치와 사유를 확인할 수 있습니다.</p>}
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
      {kinds.length > 1 && kinds.map(function (k) {
        return <button key={k[0]} type="button" style={pill(kind === k[0])} onClick={function () { refilter(setKind)(k[0]); }}>{k[1]}</button>;
      })}
      {linkable && <select aria-label="연결 상태" value={status} onChange={function (e) { refilter(setStatus)(e.target.value); }}
        style={{ fontSize: 12, padding: '4px 6px', border: '1px solid #e2e8f0', borderRadius: 6 }}>
        {STATUS.map(function (s) { return <option key={s[0]} value={s[0]}>{s[1]}</option>; })}
      </select>}
      <input aria-label="기록 검색" placeholder="번호판·차대·이름·입금자" value={qIn} style={Object.assign({}, is, { width: 190, padding: '5px 8px', fontSize: 12 })}
        onChange={function (e) { setQIn(e.target.value); }}
        onKeyUp={function (e) { if (e.key === 'Enter') refilter(setQ)(qIn.trim()); }} />
      <button className="btn btn-outline btn-sm" onClick={function () { refilter(setQ)(qIn.trim()); }}>검색</button>
      <input type="date" aria-label="시작일" value={from} style={dateIn} onChange={function (e) { refilter(setFrom)(e.target.value); }} />
      <span style={{ color: '#94a3b8' }}>~</span>
      <input type="date" aria-label="종료일" value={to} style={dateIn} onChange={function (e) { refilter(setTo)(e.target.value); }} />
      {tab === 'deposits' && kind === 'deposit' && <button className="btn btn-outline btn-sm" style={{ marginLeft: 'auto' }} onClick={function () { setHints(true); }}>참고 업체로 일괄 연결</button>}
    </div>
    {!!scope && <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8, fontSize: 12.5 }}>
      <span style={pill(true)}>범위: {scope.sheet} {scope.rowFrom}–{scope.rowTo}행</span>
      <button className="btn btn-outline btn-sm" onClick={props.onClearScope}>범위 해제</button>
    </div>}

    {linkable && selIds.length > 0 && <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: 8, padding: '8px 10px', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, fontSize: 12.5 }}>
      <b style={{ color: '#1d4ed8' }}>선택 {selIds.length}건</b>
      <button className="btn btn-blue btn-sm" disabled={busy} onClick={function () { setPicker({ ids: selIds, version: versionOf(selIds) }); }}>선택 업체 연결</button>
      <button className="btn btn-outline btn-sm" disabled={busy} onClick={function () { setUnlink({ ids: selIds, version: versionOf(selIds) }); }}>연결 해제</button>
      <button className="btn btn-outline btn-sm" disabled={busy} onClick={function () { setSel({}); }}>선택 해제</button>
    </div>}
    {!!unlink && <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginBottom: 8, padding: '8px 10px', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, fontSize: 12.5 }}>
      <span style={{ color: '#92400e' }}>{unlink.ids.length}건의 업체 연결을 해제합니다.</span>
      <button className="btn btn-blue btn-sm" disabled={busy} onClick={function () { doLink(unlink.ids, 0, unlink.version); }}>해제</button>
      <button className="btn btn-outline btn-sm" disabled={busy} onClick={function () { setUnlink(null); }}>닫기</button>
    </div>}
    {errBox(err)}

    <div style={Object.assign(isMobile ? Object.assign({}, hScroll) : { overflowX: 'auto' }, loading ? { opacity: 0.55 } : null)}>
      <table style={{ width: '100%', minWidth: 900, borderCollapse: 'collapse', background: '#fff', border: '1px solid #e2e8f0' }}>
        <thead><tr>
          {linkable && <th style={th}><input type="checkbox" aria-label="이 페이지 전체 선택" checked={rows.length > 0 && rows.every(function (r) { return sel[r.id]; })}
            onChange={function (e) { var on = e.target.checked; setSel(function (p) { var n = Object.assign({}, p); rows.forEach(function (r) { if (on) n[r.id] = true; else delete n[r.id]; }); return n; }); }} /></th>}
          {cols.map(function (c) { return <th key={c[0]} style={c[2] ? Object.assign({}, th, { textAlign: 'right' }) : th}>{c[0]}</th>; })}
        </tr></thead>
        <tbody>{rows.map(function (r) {
          var ex = open === r.id;
          return (<RecordsRow key={r.id} row={r} cols={cols} linkable={linkable} open={ex} selected={!!sel[r.id]} hist={hist} busy={busy}
            onToggle={function () { setOpen(ex ? 0 : r.id); }}
            onSelect={function () { setSel(function (p) { var n = Object.assign({}, p); if (n[r.id]) delete n[r.id]; else n[r.id] = true; return n; }); }}
            onPick={function () { setPicker({ ids: [r.id], version: r.version }); }}
            onUnlink={function () { setUnlink({ ids: [r.id], version: r.version }); }} />);
        })}
        {!rows.length && <tr><td colSpan={colCount} style={Object.assign({}, td, { padding: 20, textAlign: 'center', color: '#94a3b8' })}>{loading || !data ? '조회 중…' : '기록이 없습니다'}</td></tr>}
        </tbody>
      </table>
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10, fontSize: 12, color: '#64748b' }}>
      <span>총 {fmt(total)}건{total > 0 ? ' · ' + fmt(offset + 1) + '–' + fmt(Math.min(offset + PAGE, total)) : ''}</span>
      <button className="btn btn-outline btn-sm" disabled={offset === 0 || loading} onClick={function () { setOffset(Math.max(0, offset - PAGE)); setSel({}); setOpen(0); }}>이전</button>
      <button className="btn btn-outline btn-sm" disabled={offset + PAGE >= total || loading} onClick={function () { setOffset(offset + PAGE); setSel({}); setOpen(0); }}>다음</button>
    </div>
    {!!picker && <RecordsUnitPicker title={picker.ids.length > 1 ? '선택 ' + picker.ids.length + '건 업체 연결' : '업체 연결'} busy={busy} showToast={showToast}
      onClose={function () { setPicker(null); }} onPick={function (u) { if (u.unitId > 0) doLink(picker.ids, u.unitId, picker.version); }} />}
    {hints && <RecordsHintLinkModal jobKind={jobKind} showToast={showToast} onClose={function () { setHints(false); }}
      onDone={function () { setHints(false); setSel({}); onChanged(); }} />}
  </div>);
}

// ── 9월 이후 — 장부(정산 항목)의 폐차·이전 건, 읽기 전용 ──
function ErpItems(props) {
  var isMobile = useIsMobile();
  var [month, setMonth] = useState(curMonth() < '2026-09' ? '2026-09' : curMonth());
  var [rows, setRows] = useState(null);
  var [err, setErr] = useState('');
  useEffect(function () {
    if (!/^\d{4}-\d{2}$/.test(month)) return undefined;
    var alive = true;
    setRows(null);
    authFetch(API + '/work-records/erp-items?jobKind=' + enc(props.jobKind) + '&month=' + month)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!alive) return;
        if (!d || !d.success || !Array.isArray(d.rows)) { setErr((d && d.error) || '조회 실패'); setRows([]); return; }
        setErr(''); setRows(d.rows);
      }).catch(function () { if (alive) { setErr('조회 실패'); setRows([]); } });
    return function () { alive = false; };
  }, [props.jobKind, month, props.reloadKey]);
  return (<div>
    <p style={hintSt}>2026년 9월부터는 정산 장부에 기록된 {props.jobKind} 건을 월별로 봅니다.</p>
    <input type="month" aria-label="조회 월" min="2026-09" value={month} onChange={function (e) { setMonth(e.target.value); }}
      style={Object.assign({}, is, { width: 160, marginBottom: 10 })} />
    {errBox(err)}
    <div style={isMobile ? hScroll : { overflowX: 'auto' }}>
      <table style={{ width: '100%', minWidth: 560, borderCollapse: 'collapse', background: '#fff', border: '1px solid #e2e8f0' }}>
        <thead><tr>{['날짜', '차량번호', '업무', '업체', '소계'].map(function (h) { return <th key={h} style={h === '소계' ? Object.assign({}, th, { textAlign: 'right' }) : th}>{h}</th>; })}</tr></thead>
        <tbody>{(rows || []).map(function (r) {
          return (<tr key={r.id}><td style={td}>{r.date || '-'}</td><td style={Object.assign({}, td, { fontWeight: 700 })}>{r.carNo || '-'}</td>
            <td style={td}>{r.jobKind}</td><td style={td}>{r.unitName || '-'}</td><td style={Object.assign({}, td, { textAlign: 'right' })}>{fmt(r.subtotal)}</td></tr>);
        })}
        {!(rows && rows.length) && <tr><td colSpan={5} style={Object.assign({}, td, { padding: 20, textAlign: 'center', color: '#94a3b8' })}>{rows ? '이 달 기록이 없습니다' : '조회 중…'}</td></tr>}
        </tbody>
      </table>
    </div>
  </div>);
}

export default function CancelAgencyRecords(props) {
  var user = props.user || {};
  var showToast = props.showToast || function () {};
  var isMobile = useIsMobile();
  var [jobKind, setJobKind] = useState('폐차');
  var [sub, setSub] = useState('cards');
  var [listScope, setListScope] = useState(null);   // 장부 반영 카드에서 연 목록 범위 {tab, sheet, rowFrom, rowTo}
  var [summary, setSummary] = useState(null);
  var [reloadKey, setReloadKey] = useState(0);
  var reload = function () { setReloadKey(function (k) { return k + 1; }); };

  useEffect(function () {
    var alive = true;
    authFetch(API + '/work-records/summary?jobKind=' + enc(jobKind))
      .then(function (r) { return r.json(); })
      .then(function (d) { if (alive) setSummary(d && d.success && d.counts ? d.counts : null); })
      .catch(function () { if (alive) setSummary(null); });
    return function () { alive = false; };
  }, [jobKind, reloadKey]);

  // 실시간 — 같은 대행사·보고 있는 업무의 변경만 반영 (300ms debounce), 재연결 시 1회 재조회
  var jobKindRef = useRef(jobKind); jobKindRef.current = jobKind;
  useEffect(function () {
    var sock = getSocket();
    if (!sock) return undefined;
    var t = null;
    var onUpdated = function (d) {
      if (d && d.agencyId && user.agencyId && String(d.agencyId) !== String(user.agencyId)) return;
      if (d && d.jobKind && d.jobKind !== jobKindRef.current) return;
      if (t) clearTimeout(t);
      t = setTimeout(reload, 300);
    };
    sock.on('records:updated', onUpdated);
    sock.on('connect', reload);
    return function () {
      if (t) clearTimeout(t);
      try { sock.off('records:updated', onUpdated); } catch (e) {}
      try { sock.off('connect', reload); } catch (e) {}
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var c = summary || {};
  var item = c.item || {}, dep = c.deposit || {};
  var stat = function (label, value, extra) {
    return (<div style={{ flex: 1, minWidth: 110, padding: '9px 12px', borderRight: '1px solid #f1f5f9' }}>
      <div style={{ fontSize: 11, color: '#64748b', marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 15, fontWeight: 700, color: '#334155' }}>{fmt(value)}건</div>
      {!!extra && <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{extra}</div>}
    </div>);
  };
  var childProps = { jobKind: jobKind, reloadKey: reloadKey, showToast: showToast, onChanged: reload };
  var scope = listScope && listScope.tab === sub ? listScope : null;

  // 아래 여백 — 화면 오른쪽 아래 떠 있는 챗봇·메모 버튼 위로 마지막 줄까지 올려 볼 수 있게
  return (<div style={{ fontFamily: 'Pretendard,sans-serif', paddingBottom: 140 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
      {JOBS.map(function (j) {
        return <button key={j} className={'btn ' + (jobKind === j ? 'btn-blue' : 'btn-outline')} aria-pressed={jobKind === j}
          onClick={function () { setJobKind(j); setListScope(null); }}>{j}</button>;
      })}
      <span style={{ fontSize: 12, color: '#94a3b8' }}>2026-08-31 까지의 엑셀 {jobKind} 기록 · 업체를 연결하면 어느 업체 건인지 표시됩니다</span>
    </div>
    <div data-testid="records-summary" style={{ display: 'flex', flexWrap: 'wrap', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, overflow: 'hidden', marginBottom: 12 }}>
      {stat('건', item.total, '미연결 ' + fmt(item.unlinked) + ' · 자동 ' + fmt(item.auto) + ' · 직접 ' + fmt(item.manual))}
      {stat('입금', dep.total, '미연결 ' + fmt(dep.unlinked))}
      {stat('부속표', cnt(c.side_item))}
      {stat('조정', cnt(c.adjust))}
      {stat('제외', cnt(c.excluded))}
    </div>
    <div style={{ borderBottom: '1px solid #e2e8f0', marginBottom: 12, overflowX: 'auto' }}>
      <CaHeaderTabs isMobile={isMobile} items={SUBS.map(function (s) { return { label: s[1], on: sub === s[0], onClick: function () { setSub(s[0]); setListScope(null); } }; })} />
    </div>
    {sub === 'cards' && <RecordsCards {...childProps} userName={user.name} onOpenList={function (sc) { setListScope(sc); setSub(sc.tab); }}
      onOpenGaps={function () { setSub('gaps'); }} />}
    {sub === 'gaps' && <RecordsGaps {...childProps} userName={user.name} />}
    {sub === 'names' && <NameGroups {...childProps} />}
    {!!LIST_KINDS[sub] && <RecordList key={sub + jobKind + (scope ? '|' + scope.sheet + '|' + scope.rowFrom + '|' + scope.rowTo : '')} tab={sub} {...childProps}
      scope={scope} onClearScope={function () { setListScope(null); }} />}
    {sub === 'erp' && <ErpItems {...childProps} />}
    {sub === 'history' && <RecordsHistory {...childProps} />}
  </div>);
}
